import React from 'react';
import { FormControl, MenuItem, OutlinedInput, Select } from '@mui/material';
import { getDynamicOptionLabel } from '../../utils/dynamicFields';

export default function DynamicFieldInputV2({ field, value, error, onChange, language, inputSx, selectSx }) {
    const v = value || '';
    const isSelect = field.type === 'select';
    return (
        <FormControl fullWidth size="small" error={!!error}>
            {isSelect ? (
                <Select
                    value={v}
                    displayEmpty
                    onChange={onChange}
                    input={<OutlinedInput name={`dynamic_${field.key}`} sx={selectSx} />}
                >
                    {!field.required && <MenuItem value="">—</MenuItem>}
                    {(field.options || []).map(opt => (
                        <MenuItem value={opt.value} key={opt.value}>
                            {getDynamicOptionLabel(opt, language)}
                        </MenuItem>
                    ))}
                </Select>
            ) : (
                <OutlinedInput
                    name={`dynamic_${field.key}`}
                    type={field.type === 'integer' ? 'number' : 'text'}
                    inputProps={field.type === 'integer' ? { step: 1 } : {}}
                    value={v}
                    error={!!error}
                    onChange={onChange}
                    size="small"
                    sx={inputSx}
                />
            )}
        </FormControl>
    );
}
